import {Field, Form, Formik} from 'formik'
import * as Yup from 'yup'

import {useIntl} from 'react-intl'
import Logo from '../../../_metronic/assets/everyvisit-logo.svg'
import BG_CONTAINER from '../asset/circle-container.jpg'
import MAIN from '../asset/main.jpg'
import MAIN_2 from '../asset/main-2.jpeg'
import {LanguageList} from '../helper/languageList'
import {useForgotPassword} from '../context/useMutation'
import {GoogleReCaptchaCheckbox} from 'react-google-recaptcha-ultimate'
import {useState} from 'react'
import LogoMc from '../../../_metronic/assets/mc-logo.svg'

export default function ForgotPassword() {
  const intl = useIntl()
  const {mutateAsync, isLoading} = useForgotPassword()
  const [oldgoogleRecaptcha, setOldGoogleRecaptcha] = useState<string>('')

  const validationSchema = Yup.object({
    email: Yup.string()
      .max(100, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 100}))
      .email(intl.formatMessage({id: 'GLOBAL.VALIDATION.EMAIL'}))
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    recaptcha: Yup.string().required(intl.formatMessage({id: 'GLOBAL.VALIDATION.RECAPTCHA'})),
  })

  // const submit = async (values: any) => {
  //   handlesubmit(values)
  // }

  const handleSubmit = async (values: any) => {
    setOldGoogleRecaptcha(values.recaptcha)
    mutateAsync({
      values,
      recaptcha: oldgoogleRecaptcha,
    })
  }

  const handleExpired = (setFieldValue) => {
    setOldGoogleRecaptcha('')
    setFieldValue('recaptcha', '')
    if (typeof document !== 'undefined' && (window as any).grecaptcha) {
      ;(window as any).grecaptcha.reset()
    }
  }

  return (
    <div className='d-flex flex-column flex-root' id='kt_app_root'>
      <div className='d-flex flex-column flex-lg-row flex-column-fluid'>
        <a href='sign-in' className='d-block d-lg-none mx-auto pt-10'>
          <img alt='Logo' src={Logo} className='h-25px' />
        </a>

        <div className='d-flex flex-column flex-column-fluid flex-center w-lg-50 p-10'>
          <div className='d-flex justify-content-between flex-column-fluid flex-column w-100 mw-550px gap-10'>
            <div className='d-flex flex-stack py-2'>
              <div className='m-0'>
                <div className='d-none d-md-block'>
                  <img alt='Logo' src={LogoMc} className='h-20px' />
                  <img alt='Logo' src={Logo} className='h-25px' />
                </div>
              </div>
            </div>

            <div>
              <Formik
                className='form w-100'
                validationSchema={validationSchema}
                initialValues={{
                  email: '',
                  recaptcha: '',
                }}
                // onSubmit={handleSubmit}
                onSubmit={handleSubmit}
              >
                {({errors, touched, setFieldValue}) => (
                  <Form>
                    <div className='text-start mb-10'>
                      <h1 className='text-primary mb-3 fs-3x' data-kt-translate='sign-in-title'>
                        {intl.formatMessage({id: 'AUTH.FORGOT.TITLE'})}
                      </h1>

                      <div
                        className='text-gray-400 fw-semibold fs-6'
                        data-kt-translate='password-reset-desc'
                      >
                        {intl.formatMessage({id: 'AUTH.FORGOT.DESC'})}
                      </div>
                    </div>

                    <div className='fv-row mb-10 form-floating'>
                      <Field
                        type='text'
                        name='email'
                        className='form-control mb-2'
                        placeholder={intl.formatMessage({id: 'AUTH.INPUT.EMAIL'})}
                        maxLength={101}
                        onKeyUp={(e) => {
                          const value = e.target.value.toLowerCase()
                          const noTurkishChars = value.replaceAll(/[ğĞüÜşŞıİöÖçÇ]/g, '')
                          setFieldValue('email', noTurkishChars)
                        }}
                      />
                      <label>{intl.formatMessage({id: 'AUTH.INPUT.EMAIL'})}</label>
                      {errors.email && touched.email && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{errors.email}</div>
                        </div>
                      )}
                    </div>

                    <div className='mb-7'>
                      <GoogleReCaptchaCheckbox
                        action='FORGOT_PASSWORD'
                        callback={(token) => {
                          setFieldValue('recaptcha', token)

                          setTimeout(() => {
                            handleExpired(setFieldValue)
                          }, 60000)
                        }}
                      />
                      {errors.recaptcha && touched.recaptcha ? (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{errors.recaptcha}</div>
                        </div>
                      ) : null}
                    </div>

                    <div className='d-flex flex-stack'>
                      <div className='m-0'>
                        <button
                          // id='kt_password_reset_submit'
                          disabled={isLoading}
                          type='submit'
                          className='btn btn-primary me-2'
                          // data-kt-translate='password-reset-submit'
                        >
                          {/* <i className='bi bi-arrow-right me-3 fs-3'></i>
                          <span className='indicator-label'>
                            {intl.formatMessage({id: 'AUTH.GENERAL.SUBMIT_BUTTON'})}
                          </span>

                          <span className='indicator-progress'>
                            {intl.formatMessage({id: 'PLEASE_WAIT'})}
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span> */}

                          {isLoading ? (
                            <span data-kt-translate='general-progress'>
                              {intl.formatMessage({id: 'LOADING'})}
                            </span>
                          ) : (
                            <>
                              <i className='bi bi-arrow-right me-3 fs-3'></i>
                              <span className='indicator-label'>
                                {intl.formatMessage({id: 'AUTH.GENERAL.SUBMIT_BUTTON'})}
                              </span>
                            </>
                          )}
                        </button>
                        <a
                          href='sign-in'
                          className='btn fw-bold'
                          data-kt-translate='password-reset-cancel'
                        >
                          {intl.formatMessage({id: 'AUTH.GENERAL.BACK_BUTTON'})}
                        </a>
                      </div>
                    </div>
                    <div className='mt-10'>
                      <LanguageList />
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
            <div></div>
          </div>
        </div>

        <div
          className='d-none d-lg-flex flex-lg-row-fluid w-50 bgi-size-cover bgi-position-center bgi-no-repeat'
          style={{
            backgroundImage: `url('${BG_CONTAINER}')`,
          }}
        >
          <div className='d-flex flex-column flex-center p-15 w-100 position-relative'>
            <div
              className='rounded-circle shadow-lg d-flex flex-center position-absolute'
              style={{
                width: '380px',
                height: '380px',
                top: '12%',
                left: '12%',
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(15px)',
                overflow: 'hidden',
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
                zIndex: 2,
              }}
            >
              <img
                src={MAIN}
                alt='Mastercard Solutions'
                className='w-100 h-100'
                style={{objectFit: 'cover'}}
              />
            </div>

            <div
              className='rounded-circle shadow-lg d-flex flex-center position-absolute'
              style={{
                width: '300px',
                height: '300px',
                bottom: '12%',
                right: '12%',
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(15px)',
                overflow: 'hidden',
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
                zIndex: 1,
              }}
            >
              <img
                src={MAIN_2}
                alt='Mastercard Solutions 2'
                className='w-100 h-100'
                style={{objectFit: 'cover'}}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
